var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80001 13.8002C5.79412 13.8002 6.60001 12.9943 6.60001 12.0002C6.60001 11.0061 5.79412 10.2002 4.80001 10.2002C3.80589 10.2002 3 11.0061 3 12.0002C3 12.9943 3.80589 13.8002 4.80001 13.8002Z",
    fill: "#1C2154"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 13.8002C12.9938 13.8002 13.7997 12.9943 13.7997 12.0002C13.7997 11.0061 12.9938 10.2002 11.9997 10.2002C11.0056 10.2002 10.1997 11.0061 10.1997 12.0002C10.1997 12.9943 11.0056 13.8002 11.9997 13.8002Z",
    fill: "#1C2154"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1999 13.8002C20.194 13.8002 20.9999 12.9943 20.9999 12.0002C20.9999 11.0061 20.194 10.2002 19.1999 10.2002C18.2058 10.2002 17.3999 11.0061 17.3999 12.0002C17.3999 12.9943 18.2058 13.8002 19.1999 13.8002Z",
    fill: "#1C2154"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.1b18babb.svg";
export { ForwardRef as ReactComponent };